import LocalizedStrings from 'localized-strings';

interface CreateNewTransferAddReceiptLocalizedType {
  title: string;
  description: string;
  typeOfDocumentsAccepted: string;
  dropMessage: string;
  documentRib: string;
  documentBill: string;
  receipt: string;
  see: string;
  delete: string;
  next: string;
}

export default new LocalizedStrings<CreateNewTransferAddReceiptLocalizedType>({
  en: {
    delete: 'Delete',
    description:
      'For certain transfers, we are required by law to ask you for a supporting document. Without a valid supporting document, your transfer may be cancelled.',
    documentBill: 'Corresponding invoice, receipt, payslip…',
    documentRib:
      'A RIB document in case of a transfer to one of your accounts;',
    dropMessage: 'Drop your receipt here',
    next: 'Next',
    receipt: 'Receipt',
    see: 'See',
    title: 'Add a supporting document',
    typeOfDocumentsAccepted: 'Type of documents accepted:',
  },
  fr: {
    delete: 'Supprimer',
    description:
      'Pour certains virements, la loi nous oblige à vous demander un justificatif. Sans justificatif valide, votre virement risque d’être annulé.',
    documentBill: 'Facture correspondante, reçu, bulletin de salaire…',
    documentRib: 'Un document RIB en cas de transfert vers un de vos comptes ;',
    dropMessage: 'Déposez votre justificatif ici',
    next: 'Suivant',
    receipt: 'Justificatif',
    see: 'Voir',
    title: 'Ajoutez un justificatif',
    typeOfDocumentsAccepted: 'Types de documents acceptés :',
  },
} as const);
